import { useEffect } from 'react';

import { S3_PMTILES_URL } from '@constants/s3.constants';
import { useSelector } from 'react-redux';
import { useUploadedFloodFeatureCollection } from '../../../utils/queries/upload.queries';

function FloodsLayer({
  map, scenario = '10', floodColor, selectedValue, 
}) {
  const color = floodColor || 'rgba(3, 103, 165, 0.3)'
  const currentBaseMapStyle = useSelector(state => state.maplibreMap.currentBaseMapStyle)
  const { data: selectedFeatureCollection } = useUploadedFloodFeatureCollection(selectedValue)

  useEffect(() => {
    if (selectedFeatureCollection && selectedFeatureCollection?.length > 0) {
      map.addSource('floods', {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: selectedFeatureCollection,
        },
      });
      map.addLayer({
        id: 'floods',
        type: 'fill',
        source: 'floods',
        paint: {
          'fill-color': color,
          'fill-outline-color': '#777',
        },
      }, 'z-index-2');
    } else {
      map.addSource('floods', {
        type: 'vector',
        url: `pmtiles://${S3_PMTILES_URL}/floods.pmtiles`,
      });
    
      map.addLayer({
        id: 'floods',
        type: 'fill',
        source: 'floods',
        'source-layer': scenario,
        paint: {
          'fill-color': color,
          'fill-outline-color': '#777',
        },
      }, 'z-index-2');
    }
    
    return () => {
      if (map && !map._removed) {
        if (map.getLayer('floods')) {
          map.removeLayer('floods');
        }
      
        if (map.getSource('floods')) {
          map.removeSource('floods');
        }
      }
    };
  }, [color, map, scenario, currentBaseMapStyle, selectedFeatureCollection]);

  return null;
}

export default FloodsLayer;